module.exports = __webpack_public_path__ + "img/post.057f22f8.png";